"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLAN_SUGGESTED_COPY = exports.PLAN_ADD_BUCKET_DESCRIPTION_COPY = exports.PLAN_ADD_BUCKET_COPY = exports.PLAN_SPLASH_BUBBLE_BODY_COPY = exports.PLAN_SPLASH_BUBBLE_TITLE_COPY = exports.PLAN_MOVED_TO_SAVINGS_COPY = exports.PLAN_KEPT_IN_CHECKING_COPY = exports.PLAN_PER_PAY_PERIOD_OR_PCT_COPY = exports.PLAN_PER_PAY_PERIOD_COPY = exports.PLAN_PILL_SNOWBALL_COPY = exports.PLAN_PILL_AVALANCHE_COPY = exports.PLAN_PILL_IN_SAVINGS_COPY = exports.PLAN_PILL_IN_CHECKING_COPY = exports.PLAN_PILL_COVERED_COPY = exports.PLAN_GROUP_SAVINGS_GOALS_COPY = exports.PLAN_GROUP_DEBT_COPY = exports.PLAN_GROUP_GUILT_FREE_COPY = exports.PLAN_GROUP_ESSENTIALS_COPY = exports.PLAN_BUCKETS_SUBTITLE_COPY = exports.PLAN_BUCKETS_TITLE_COPY = exports.PLAN_MANAGE_IN_UPCOMING_COPY = exports.PLAN_BILLS_FOOTNOTE_COPY = exports.PLAN_BILL_PAID_COPY = exports.PLAN_BILLS_PHONE_TITLE_COPY = exports.PLAN_BILLS_TITLE_COPY = exports.PLAN_OVERPLANNED_COPY = exports.PLAN_EVERY_DOLLAR_COPY = exports.PLAN_PART_NOT_PLANNED_COPY = exports.PLAN_PART_SAVINGS_GOALS_COPY = exports.PLAN_PART_DEBT_COPY = exports.PLAN_PART_SPLASH_FUND_COPY = exports.PLAN_PART_ESSENTIALS_COPY = exports.PLAN_PAYCHECKS_LINK_COPY = exports.PLAN_SUMMARY_LABEL_NEXT_COPY = exports.PLAN_SUMMARY_LABEL_COPY = exports.PLAN_WRITE_FAILURE = exports.PLAN_LOAD_ERROR_COPY = exports.PLAN_THIS_PERIOD_COPY = exports.PLAN_TITLE_COPY = exports.PLAN_CAR_SUGGESTION_COPY = exports.PLAN_TRIP_SUGGESTION_COPY = exports.PLAN_SAVINGS_NAME_COPY = exports.PLAN_CHECKING_CUSHION_NAME_COPY = exports.PLAN_YEARLY_COSTS_NAME_COPY = exports.PLAN_TRANSPORTATION_NAME_COPY = exports.PLAN_GROCERIES_NAME_COPY = exports.PLAN_HOLIDAYS_GIFTS_NAME_COPY = exports.PLAN_EMERGENCY_FUND_NAME_COPY = exports.PLAN_DEBT_PAYOFF_NAME_COPY = exports.PLAN_SPLASH_FUND_NAME_COPY = void 0;
exports.PLAN_SETUP_INTRO_BODY_COPY = exports.PLAN_SETUP_INTRO_HEADING_COPY = exports.PLAN_SETUP_INTRO_KICKER_COPY = exports.PLAN_RENAME_SPLASH_COPY = exports.PLAN_RENAME_DUPLICATE_COPY = exports.PLAN_RENAME_TOO_LONG_COPY = exports.PLAN_RENAME_EMPTY_COPY = exports.PLAN_BUCKET_NAME_MAX_LENGTH = exports.PLAN_BUCKET_NAME_COPY = exports.PLAN_ADD_SAVINGS_GOAL_COPY = exports.PLAN_ADD_SPENDING_COPY = exports.PLAN_CATEGORY_RULES_SHOW_ALL_COPY = exports.PLAN_EDIT_KEPT_IN_COPY = exports.PLAN_EDIT_TARGET_COPY = exports.PLAN_CATEGORY_RULES_CHANGE_ON_PLAN_COPY = exports.PLAN_CATEGORY_RULES_NO_BUCKET_COPY = exports.PLAN_EDIT_ADD_CATEGORY_COPY = exports.PLAN_EDIT_CATEGORIES_COPY = exports.PLAN_DELETE_BUCKET_COPY = exports.PLAN_RENAME_COPY = exports.PLAN_SAVE_COPY = exports.PLAN_CANCEL_COPY = exports.PLAN_NO_PAYCHECK_COPY = exports.PLAN_SYNC_FAILED_COPY = exports.PLAN_REVIEW_PLAN_COPY = exports.PLAN_HOW_IT_WORKS_UNSPENT_COPY = exports.PLAN_HOW_IT_WORKS_PURCHASES_COPY = exports.PLAN_HOW_IT_WORKS_BILLS_COPY = exports.PLAN_HOW_IT_WORKS_TITLE_COPY = exports.PLAN_START_CHECKIN_COPY = exports.PLAN_PREVIEW_CHECKIN_COPY = exports.PLAN_CHECKIN_PITCH_COPY = exports.PLAN_NEXT_PAYDAY_TITLE_COPY = exports.PLAN_CHANGE_ORDER_IN_PLAN_COPY = exports.PLAN_CHANGE_ORDER_COPY = exports.PLAN_ORDER_FOOTNOTE_COPY = exports.PLAN_ORDER_ALWAYS_LAST_COPY = exports.PLAN_ORDER_ALWAYS_FIRST_COPY = exports.PLAN_ORDER_OTHER_GOALS_COPY = exports.PLAN_ORDER_EMERGENCY_FUND_COPY = exports.PLAN_ORDER_SPLASH_FUND_COPY = exports.PLAN_ORDER_NOT_PLANNED_COPY = exports.PLAN_ORDER_INTRO_COPY = exports.PLAN_ORDER_TITLE_COPY = exports.PLAN_ADD_TO_BUCKET_COPY = exports.PLAN_PARK_IT_COPY = exports.PLAN_NOT_PLANNED_OVERPLANNED_COPY = exports.PLAN_NOT_PLANNED_UNPLANNED_COPY = exports.PLAN_NOT_PLANNED_TITLE_COPY = exports.PLAN_SET_UP_DEBT_PAYOFF_COPY = void 0;
exports.PLAN_SETUP_ANOTHER_BUCKET_DETAIL_COPY = exports.PLAN_SETUP_ANOTHER_BUCKET_COPY = exports.PLAN_SETUP_WHATS_LEFT_BODY_COPY = exports.PLAN_SETUP_WHATS_LEFT_KICKER_COPY = exports.PLAN_SETUP_ADD_ANOTHER_COPY = exports.PLAN_SETUP_GOALS_BODY_COPY = exports.PLAN_SETUP_GOALS_HEADING_COPY = exports.PLAN_SETUP_GOALS_KICKER_COPY = exports.PLAN_SETUP_EF_IN_CHECKING_COPY = exports.PLAN_SETUP_EF_IN_SAVINGS_COPY = exports.PLAN_SETUP_NOT_YET_DETAIL_COPY = exports.PLAN_SETUP_NOT_YET_COPY = exports.PLAN_SETUP_YES_DETAIL_COPY = exports.PLAN_SETUP_HAS_SAVINGS_YES_COPY = exports.PLAN_SETUP_HAS_SAVINGS_QUESTION_COPY = exports.PLAN_SETUP_SAVINGS_HEADING_COPY = exports.PLAN_SETUP_SAVINGS_KICKER_COPY = exports.PLAN_SETUP_PCT_TOGGLE_COPY = exports.PLAN_SETUP_DOLLARS_TOGGLE_COPY = exports.PLAN_SETUP_DEBT_EXTRA_BODY_COPY = exports.PLAN_SETUP_DEBT_EXTRA_COPY = exports.PLAN_SETUP_PAYS_IN_FULL_COPY = exports.PLAN_SETUP_DEBTS_QUESTION_COPY = exports.PLAN_SETUP_STEP_CHANGED_COPY = exports.PLAN_SETUP_DEBTS_HEADING_COPY = exports.PLAN_SETUP_DEBTS_KICKER_COPY = exports.PLAN_SETUP_SPLASH_EXPLAINER_COPY = exports.PLAN_SETUP_SPLASH_OPTION_COPY = exports.PLAN_SETUP_SPLASH_HEADING_COPY = exports.PLAN_SETUP_SPLASH_KICKER_COPY = exports.PLAN_SETUP_ESSENTIALS_BODY_COPY = exports.PLAN_SETUP_ESSENTIALS_HEADING_COPY = exports.PLAN_SETUP_ESSENTIALS_KICKER_COPY = exports.PLAN_EACH_PAY_PERIOD_COPY = exports.PLAN_SETUP_NEXT_COPY = exports.PLAN_SETUP_STEP_SKIPPED_COPY = exports.PLAN_SETUP_SKIP_COPY = exports.PLAN_SETUP_BACK_COPY = exports.PLAN_SETUP_TAB_WHATS_LEFT_COPY = exports.PLAN_SETUP_TAB_GOALS_COPY = exports.PLAN_SETUP_TAB_SAVINGS_COPY = exports.PLAN_SETUP_TAB_DEBTS_COPY = exports.PLAN_SETUP_TAB_SPLASH_COPY = exports.PLAN_SETUP_TAB_ESSENTIALS_COPY = exports.PLAN_SETUP_BUCKET_IT_COPY = exports.PLAN_SETUP_NOT_NOW_COPY = exports.PLAN_SETUP_PAY_PERIOD_COPY = exports.PLAN_SETUP_BILLS_COPY = exports.PLAN_SETUP_COMING_IN_COPY = exports.PLAN_SETUP_INTRO_BODY_PLANNED_COPY = void 0;
exports.PLAN_CHECKING_TO_SAVINGS_COPY = exports.PLAN_CHECKIN_MOVE_BODY_COPY = exports.PLAN_CHECKIN_MOVE_HEADING_COPY = exports.PLAN_USE_THIS_PLAN_COPY = exports.PLAN_OPEN_FULL_PLAN_COPY = exports.PLAN_CHECKIN_LEAVE_DETAIL_COPY = exports.PLAN_CHECKIN_LEAVE_COPY = exports.PLAN_CHECKIN_ANOTHER_BUCKET_DETAIL_COPY = exports.PLAN_CHECKIN_ANOTHER_BUCKET_COPY = exports.PLAN_CHECKIN_THATS_RIGHT_COPY = exports.PLAN_CHECKIN_PREVIEW_NOTICE_COPY = exports.PLAN_CHECKIN_AMOUNT_LABEL_COPY = exports.PLAN_CHECKIN_AMOUNT_DIFFERENT_COPY = exports.PLAN_CHECKIN_MATCHES_COPY = exports.PLAN_CHECKIN_PAYCHECK_HEADING_COPY = exports.PLAN_CHECKIN_STEP_MOVE_COPY = exports.PLAN_CHECKIN_STEP_PLAN_COPY = exports.PLAN_CHECKIN_STEP_PAYCHECK_COPY = exports.PLAN_CHECKIN_TITLE_COPY = exports.PLAN_STAGE_TRIP_REASON_COPY = exports.PLAN_TYPE_GOAL_COPY = exports.PLAN_TYPE_DEBT_COPY = exports.PLAN_TYPE_SAVINGS_COPY = exports.PLAN_TYPE_SPENDING_AVERAGE_COPY = exports.planStageLiveLine = exports.PLAN_SKIP_FOR_NOW_COPY = exports.PLAN_OTHER_GOAL_COPY = exports.PLAN_MORE_GOALS_COPY = exports.PLAN_STAGE2_ASK_COPY = exports.PLAN_STAGE1_ASK_COPY = exports.PLAN_STAGE1_OTHER_PART_COPY = exports.PLAN_STAGE1_SPLASH_DESCRIPTION_COPY = exports.PLAN_USUAL_TITLE_COPY = exports.PLAN_SEE_FIX_BILLS_COPY = exports.PLAN_BILLS_FOUND_COPY = exports.PLAN_WATERFALL_REMAINING_COPY = exports.PLAN_WATERFALL_BILLS_COPY = exports.PLAN_WATERFALL_BALANCE_COPY = exports.PLAN_WATERFALL_STAGE3_COPY = exports.PLAN_WATERFALL_STAGE2_COPY = exports.PLAN_UNTIL_PAYDAY_COPY = exports.PLAN_GO_TO_HOME_COPY = exports.PLAN_SETUP_DONE_ORDER_BODY_COPY = exports.PLAN_SETUP_EACH_PAY_PERIOD_COPY = exports.PLAN_SETUP_DONE_HEADING_COPY = exports.PLAN_SETUP_DONE_KICKER_COPY = exports.PLAN_SETUP_FINISH_COPY = exports.PLAN_EVERY_PAYDAY_COPY = exports.PLAN_SETUP_LEAVE_DETAIL_COPY = exports.PLAN_SETUP_LEAVE_COPY = void 0;
exports.PLAN_DEBT_APR_NEEDED_COPY = exports.PLAN_DEBT_APR_LABEL_COPY = exports.PLAN_DEBT_INCLUDE_COPY = exports.PLAN_DEBT_NEVER_PAID_OFF_COPY = exports.PLAN_NOT_MOVED_YET_COPY = exports.PLAN_FINISH_CHECKIN_COPY = exports.PLAN_BACK_TO_HOME_COPY = exports.PLAN_SAFE_UNTIL_PAYDAY_COPY = exports.PLAN_START_MY_PERIOD_COPY = exports.PLAN_EXTRA_DEBT_PAYMENT_COPY = void 0;
exports.planPeriodSentence = planPeriodSentence;
exports.planNextTabCopy = planNextTabCopy;
exports.planComingInSentence = planComingInSentence;
exports.planComingInPhoneSentence = planComingInPhoneSentence;
exports.planParkedOnPaydaySentence = planParkedOnPaydaySentence;
exports.planNotPlannedYetTitle = planNotPlannedYetTitle;
exports.planParkItInCopy = planParkItInCopy;
exports.planBillsSentence = planBillsSentence;
exports.planPeriodPhoneSentence = planPeriodPhoneSentence;
exports.planBillsPhoneSubline = planBillsPhoneSubline;
exports.planBillsPhoneRow = planBillsPhoneRow;
exports.planBillChipSentence = planBillChipSentence;
exports.planBillsMoreSentence = planBillsMoreSentence;
exports.planMathLine = planMathLine;
exports.planMathPhoneLine = planMathPhoneLine;
exports.planCoveredFromSentence = planCoveredFromSentence;
exports.planParkedBoxSentence = planParkedBoxSentence;
exports.planPctEqualsCopy = planPctEqualsCopy;
exports.planSetAsideProgressSentence = planSetAsideProgressSentence;
exports.planSetAsidePhoneProgressSentence = planSetAsidePhoneProgressSentence;
exports.planDebtDetailSentence = planDebtDetailSentence;
exports.planDebtLeftSentence = planDebtLeftSentence;
exports.planSuggestionSentence = planSuggestionSentence;
exports.planNotPlannedParkedSentence = planNotPlannedParkedSentence;
exports.planNotPlannedParkedNeutralSentence = planNotPlannedParkedNeutralSentence;
exports.planOrderEssentialsLabel = planOrderEssentialsLabel;
exports.planMoveUpLabel = planMoveUpLabel;
exports.planMoveDownLabel = planMoveDownLabel;
exports.planPaydayAmountSentence = planPaydayAmountSentence;
exports.planNextPeriodBanner = planNextPeriodBanner;
exports.planCheckingShortUncoveredSentence = planCheckingShortUncoveredSentence;
exports.planPaycheckLessBanner = planPaycheckLessBanner;
exports.planStepperLabel = planStepperLabel;
exports.planRaiseFromParkedSentence = planRaiseFromParkedSentence;
exports.planLowerToParkedSentence = planLowerToParkedSentence;
exports.planNoParkingSentence = planNoParkingSentence;
exports.planRaiseFromNotPlannedSentence = planRaiseFromNotPlannedSentence;
exports.planShortfallParkedSentence = planShortfallParkedSentence;
exports.planShortfallNotPlannedSentence = planShortfallNotPlannedSentence;
exports.planShortfallNothingSentence = planShortfallNothingSentence;
exports.planTakeFromLabel = planTakeFromLabel;
exports.planTakeFromChoiceSentence = planTakeFromChoiceSentence;
exports.planFromNowOnSentence = planFromNowOnSentence;
exports.planCategoryRulesBucketSentence = planCategoryRulesBucketSentence;
exports.planCategoryRulesEmptySentence = planCategoryRulesEmptySentence;
exports.planStepLessLabel = planStepLessLabel;
exports.planStepMoreLabel = planStepMoreLabel;
exports.planRemoveCategoryLabel = planRemoveCategoryLabel;
exports.planArchiveReturnsSentence = planArchiveReturnsSentence;
exports.planArchiveHeldInCheckingSentence = planArchiveHeldInCheckingSentence;
exports.planArchiveHeldInSavingsSentence = planArchiveHeldInSavingsSentence;
exports.planSetupAfterBillsPill = planSetupAfterBillsPill;
exports.planSetupLeftToPlanPill = planSetupLeftToPlanPill;
exports.planSetupUsuallySentence = planSetupUsuallySentence;
exports.planSetupSplashBody = planSetupSplashBody;
exports.planSetupCarryingSentence = planSetupCarryingSentence;
exports.planSetupLoanSentence = planSetupLoanSentence;
exports.planSetupFoundDebtSentence = planSetupFoundDebtSentence;
exports.planSetupStoppedDebtSentence = planSetupStoppedDebtSentence;
exports.planSetupFoundNeedsDetailsSentence = planSetupFoundNeedsDetailsSentence;
exports.planSetupDebtsBody = planSetupDebtsBody;
exports.planSetupSavingsBody = planSetupSavingsBody;
exports.planSetupGoalSentence = planSetupGoalSentence;
exports.planSetupGoalCappedSentence = planSetupGoalCappedSentence;
exports.planSetupGoalNoRoomSentence = planSetupGoalNoRoomSentence;
exports.planSetupWhatsLeftHeading = planSetupWhatsLeftHeading;
exports.planParkInCopy = planParkInCopy;
exports.planSetupParkDetail = planSetupParkDetail;
exports.planSetupDoneParkedName = planSetupDoneParkedName;
exports.planNameAmountSentence = planNameAmountSentence;
exports.planStagesHeader = planStagesHeader;
exports.planWaterfallStage1Sentence = planWaterfallStage1Sentence;
exports.planUsualSentence = planUsualSentence;
exports.planCreateBucketsCopy = planCreateBucketsCopy;
exports.planStage2Banner = planStage2Banner;
exports.planStage2Sentence = planStage2Sentence;
exports.planLiveLineSentence = planLiveLineSentence;
exports.planStage3Banner = planStage3Banner;
exports.planEachPayPeriodTotal = planEachPayPeriodTotal;
exports.planStageEmergencyReason = planStageEmergencyReason;
exports.planStageDebtReason = planStageDebtReason;
exports.planStageHolidaysReason = planStageHolidaysReason;
exports.planCheckinPaycheckLabel = planCheckinPaycheckLabel;
exports.planCheckinDiffersCopy = planCheckinDiffersCopy;
exports.planCheckinPeriodSentence = planCheckinPeriodSentence;
exports.planCorrectionSeenSentence = planCorrectionSeenSentence;
exports.planCheckinPlanHeading = planCheckinPlanHeading;
exports.planCheckinPlanSentence = planCheckinPlanSentence;
exports.planCheckinBecomesCopy = planCheckinBecomesCopy;
exports.planRaiseSuggestionSentence = planRaiseSuggestionSentence;
exports.planCheckinKeptInCheckingSentence = planCheckinKeptInCheckingSentence;
exports.planCheckinMoveSentence = planCheckinMoveSentence;
exports.planDebtMoveDetail = planDebtMoveDetail;
exports.planCheckinDoneHeading = planCheckinDoneHeading;
exports.planCheckinDoneSentence = planCheckinDoneSentence;
exports.planCoveredHomeSentence = planCoveredHomeSentence;
exports.planExtraDebtMoveSentence = planExtraDebtMoveSentence;
exports.planCoveredFromNotPlannedSentence = planCoveredFromNotPlannedSentence;
exports.planCheckingShortSentence = planCheckingShortSentence;
exports.planCheckingShortFromNotPlannedSentence = planCheckingShortFromNotPlannedSentence;
exports.planNotMovedYetSentence = planNotMovedYetSentence;
exports.planDebtsFoundSentence = planDebtsFoundSentence;
exports.planDebtFirstCopy = planDebtFirstCopy;
exports.planDebtStrategySummary = planDebtStrategySummary;
exports.planDebtCarryingSentence = planDebtCarryingSentence;
/**
 * Plan's words (Anthony's Plan spec, 2026-10-15; ANTHONY-PLAN-2026-10-18.md, task D),
 * shared by both apps and by the server's sentences under rule 17.
 *
 * Verbatim from the spec. Each constant's source is one of:
 * - "Part 1": the spec's own text (the md's Part 1, checked word for word against the
 *   docx on 2026-10-19);
 * - "I<n>": words drawn in his image n and not in his text (the md's Part 2);
 * - "ours": a gap his material doesn't settle, recorded in the contract PR. Each is the
 *   pattern of his nearest line, and is his to overrule.
 *
 * Helpers take preformatted dates and currency ("$1,716", "Oct 26"), as homeCopy does,
 * so each app keeps its own formatting. The server builds every `sentence` in
 * `/api/plan/` from these same words; clients that restack at large text rebuild a line
 * from its parts with the same helper.
 *
 * Names are G1 / PL-126's: Splash Fund, Debt payoff, Emergency fund, Holidays & gifts.
 * "Discretionary" only ever describes Splash Fund's categories (Stage 1), never a bucket.
 */
const moneyDefinitionsCopy_1 = require("./moneyDefinitionsCopy");
const homeSummary_1 = require("./homeSummary");
const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;
/** "Groceries and Transportation"; "Groceries, Transportation and Pets" (G5). */
function joinNames(names) {
    if (names.length <= 1)
        return names.join("");
    return `${names.slice(0, -1).join(", ")} and ${names[names.length - 1]}`;
}
// ── Bucket names (PL-126, G1) ───────────────────────────────────────────────────────
exports.PLAN_SPLASH_FUND_NAME_COPY = "Splash Fund";
exports.PLAN_DEBT_PAYOFF_NAME_COPY = "Debt payoff";
exports.PLAN_EMERGENCY_FUND_NAME_COPY = "Emergency fund";
exports.PLAN_HOLIDAYS_GIFTS_NAME_COPY = "Holidays & gifts";
exports.PLAN_GROCERIES_NAME_COPY = "Groceries";
exports.PLAN_TRANSPORTATION_NAME_COPY = "Transportation";
exports.PLAN_YEARLY_COSTS_NAME_COPY = "Yearly costs";
exports.PLAN_CHECKING_CUSHION_NAME_COPY = "Checking cushion";
/** PL-25 / PL-114: where parking goes once the Emergency fund is at its target. Part 1. */
exports.PLAN_SAVINGS_NAME_COPY = "Savings";
/** A goal suggestion (Part 1's setup table). The user names the goal itself. */
exports.PLAN_TRIP_SUGGESTION_COPY = "Trip";
exports.PLAN_CAR_SUGGESTION_COPY = "Car";
// ── Header (PL-01) ──────────────────────────────────────────────────────────────────
exports.PLAN_TITLE_COPY = "Your plan"; // Part 1
exports.PLAN_THIS_PERIOD_COPY = "This period"; // Part 1
/** I1: "Where each paycheck goes · Pay period Oct 12 – Oct 25". */
function planPeriodSentence(start, end) {
    return `Where each paycheck goes · Pay period ${start} – ${end}`;
}
/** I1: the Next tab, "Next · starts Oct 26". */
function planNextTabCopy(start) {
    return `Next · starts ${start}`;
}
// ── Summary (PL-02–PL-04) ───────────────────────────────────────────────────────────
/** The Plan page's failed-load notice, both apps (Paul, 2026-10-19). */
exports.PLAN_LOAD_ERROR_COPY = "We couldn't load your plan. Try again.";
/** A failed Plan write, for the shared `writeFailureCopy` (mobile's D16, moved to shared,
 *  Paul 2026-10-19): "Couldn't save your plan." + the server's reason, or this line. */
exports.PLAN_WRITE_FAILURE = {
    action: "save your plan",
    unchanged: "Your plan hasn't changed.",
};
exports.PLAN_SUMMARY_LABEL_COPY = "Left after bills this pay period"; // I1
/** G34 (ours): the same label over the Next tab's figures; the server picks it per tab
 *  as `PlanSummary.label`. */
exports.PLAN_SUMMARY_LABEL_NEXT_COPY = "Left after bills next pay period";
/** I1: "Coming in $4,900 · bills $3,184". */
function planComingInSentence(comingIn, bills) {
    return `Coming in ${comingIn} · bills ${bills}`;
}
/** I8, the phone's wording of the same line: "$4,900 coming in · $3,184 bills". */
function planComingInPhoneSentence(comingIn, bills) {
    return `${comingIn} coming in · ${bills} bills`;
}
exports.PLAN_PAYCHECKS_LINK_COPY = "Paychecks in Upcoming"; // Part 1
exports.PLAN_PART_ESSENTIALS_COPY = "Essentials"; // Part 1
exports.PLAN_PART_SPLASH_FUND_COPY = "Splash Fund"; // Part 1
exports.PLAN_PART_DEBT_COPY = "Debt"; // Part 1
exports.PLAN_PART_SAVINGS_GOALS_COPY = "Savings & goals"; // Part 1
exports.PLAN_PART_NOT_PLANNED_COPY = "Not planned yet"; // Part 1
/** PL-03, green panel. I1. */
exports.PLAN_EVERY_DOLLAR_COPY = "Every dollar has a job";
/** PL-03: "Anything left on payday is parked in your Emergency fund." I1. */
function planParkedOnPaydaySentence(target) {
    return `Anything left on payday is parked in your ${target}.`;
}
/** PL-03 / PL-111, amber: "$146 not planned yet". Part 1. */
function planNotPlannedYetTitle(amount) {
    return `${amount} not planned yet`;
}
/** "Park it in Emergency fund". Part 1. */
function planParkItInCopy(target) {
    return `Park it in ${target}`;
}
/** PL-03 / PL-112, red. Part 1. */
exports.PLAN_OVERPLANNED_COPY = "Planned more than you have.";
// ── ① Bills come first (PL-05, PL-101) ─────────────────────────────────────────────
exports.PLAN_BILLS_TITLE_COPY = "Bills come first"; // I1
/** I1: "10 bills · 6 paid, 4 still coming ($368)". */
function planBillsSentence(count, paid, stillComing, stillComingAmount) {
    return `${plural(count, "bill", "bills")} · ${paid} paid, ${stillComing} still coming (${stillComingAmount})`;
}
/** I8, the phone Bills row's title. */
exports.PLAN_BILLS_PHONE_TITLE_COPY = "Bills";
/** I8, the phone's header line: "Pay period Oct 12 – Oct 25" (no "Where each paycheck goes"). */
function planPeriodPhoneSentence(start, end) {
    return `Pay period ${start} – ${end}`;
}
/** I8, the Bills row's sub-line under its "Bills" title: "10 bills · 4 still coming ($368)". */
function planBillsPhoneSubline(count, stillComing, amount) {
    return `${plural(count, "bill", "bills")} · ${stillComing} still coming (${amount})`;
}
/** I8, the phone's one row as a single line: "Bills · 10 bills · 4 still coming ($368)". */
function planBillsPhoneRow(count, stillComing, amount) {
    return `Bills · ${planBillsPhoneSubline(count, stillComing, amount)}`;
}
exports.PLAN_BILL_PAID_COPY = "paid"; // I1
/** I1: "Rent · paid", "Student loan · Oct 20". */
function planBillChipSentence(name, paidOrDate) {
    return `${name} · ${paidOrDate}`;
}
/** I1: "+ 5 more · $336". */
function planBillsMoreSentence(count, amount) {
    return `+ ${count} more · ${amount}`;
}
exports.PLAN_BILLS_FOOTNOTE_COPY = "Includes minimum payments on your cards and loans. Amounts and dates live in Upcoming."; // I1
exports.PLAN_MANAGE_IN_UPCOMING_COPY = "Manage in Upcoming"; // Part 1
// ── ② Your buckets (PL-06–PL-10, PL-88) ────────────────────────────────────────────
exports.PLAN_BUCKETS_TITLE_COPY = "Your buckets"; // Part 1
exports.PLAN_BUCKETS_SUBTITLE_COPY = "Only the ones you chose. Unspent money stays and builds up."; // I1
exports.PLAN_GROUP_ESSENTIALS_COPY = "Essentials"; // Part 1
exports.PLAN_GROUP_GUILT_FREE_COPY = "Guilt-free"; // Part 1
exports.PLAN_GROUP_DEBT_COPY = "Debt"; // Part 1
exports.PLAN_GROUP_SAVINGS_GOALS_COPY = "Savings & goals"; // Part 1
exports.PLAN_PILL_COVERED_COPY = "Covered"; // Part 1
exports.PLAN_PILL_IN_CHECKING_COPY = "In checking"; // Part 1
exports.PLAN_PILL_IN_SAVINGS_COPY = "In savings"; // Part 1
exports.PLAN_PILL_AVALANCHE_COPY = "Highest rate first"; // I1 (Part 1: "highest rate first")
exports.PLAN_PILL_SNOWBALL_COPY = "Smallest balance first"; // Part 1's "smallest balance first", as a pill
/**
 * PL-07 / G12, a spending row's math line. One tail only: the carry-over math when
 * something carried, else the Safe-to-spend note on Splash Fund, else "you usually
 * spend". With the bank unreachable (PL-119) "left" is hidden, and so is the
 * Safe-to-spend note that describes it (ours).
 *
 * "$300 planned + $20 carried over = $320 this period · $132 spent · $188 left" (Part 1)
 * "$90 planned · $38 spent · $52 left · you usually spend $86" (I1)
 * "$480 planned · $177 spent · $303 left (your Safe to spend on Home)" (I1)
 */
function planMathLine(parts) {
    const head = parts.tail === "carried"
        ? `${parts.planned} planned + ${parts.carried} carried over = ${parts.total} this period`
        : `${parts.planned} planned`;
    let line = `${head} · ${parts.spent} spent`;
    if (parts.showLeft) {
        line += ` · ${parts.left} left`;
        if (parts.tail === "safe_to_spend")
            line += " (your Safe to spend on Home)";
    }
    if (parts.tail === "usual")
        line += ` · you usually spend ${parts.usual}`;
    return line;
}
/**
 * I8 / PL-102, the phone's row line: what's left, then the same one tail as G12, shorter.
 * "$188 left · $20 carried over", "$303 left · Safe to spend on Home",
 * "$52 left · gas, parking, EV" (the row's category words, where desktop says "you
 * usually spend"). With the bank unreachable (PL-119) "left" and the Safe-to-spend note
 * go, as on desktop (ours); what remains may be "".
 */
function planMathPhoneLine(parts) {
    const bits = [];
    if (parts.showLeft)
        bits.push(`${parts.left} left`);
    if (parts.tail === "carried")
        bits.push(`${parts.carried} carried over`);
    if (parts.tail === "safe_to_spend" && parts.showLeft)
        bits.push("Safe to spend on Home");
    if (parts.tail === "usual" && parts.categoryWords)
        bits.push(parts.categoryWords);
    return bits.join(" · ");
}
/** PL-28 / PL-115: "$40 covered from Splash Fund". Part 1. */
function planCoveredFromSentence(amount, from) {
    return `${amount} covered from ${from}`;
}
exports.PLAN_PER_PAY_PERIOD_COPY = "per pay period"; // Part 1
exports.PLAN_PER_PAY_PERIOD_OR_PCT_COPY = "per pay period · or set a %"; // I1
/** I1: "$250 + $146 parked". */
function planParkedBoxSentence(planned, parked) {
    return `${planned} + ${parked} parked`;
}
/** PL-31: "15% = $257 this paycheck". Part 1. */
function planPctEqualsCopy(pct, dollars) {
    return `${pct} = ${dollars} this paycheck`;
}
exports.PLAN_KEPT_IN_CHECKING_COPY = "Kept in checking, so it can cover overspending"; // I1
exports.PLAN_MOVED_TO_SAVINGS_COPY = "Moved to savings on payday"; // I1
/** I1: "$2,600 of $5,000 · ready by January". Without a target: "$400 saved" (ours). */
function planSetAsideProgressSentence(balance, target, readyBy) {
    const head = target === null ? `${balance} saved` : `${balance} of ${target}`;
    return readyBy === null ? head : `${head} · ready by ${readyBy}`;
}
/** I8, the phone's progress line: parking replaces the ready-by date when there is
 *  any ("$2,600 of $5,000 · $250 + $146 parked"); otherwise it's the desktop line
 *  ("$1,200 of $3,000 · ready by June 1"). `parkedBox` is planParkedBoxSentence's. */
function planSetAsidePhoneProgressSentence(balance, target, parkedBox, readyBy) {
    if (parkedBox === null)
        return planSetAsideProgressSentence(balance, target, readyBy);
    const head = target === null ? `${balance} saved` : `${balance} of ${target}`;
    return `${head} · ${parkedBox}`;
}
/** PL-88: "Extra on top of minimums · now paying Store card (29.9%), then Rewards credit
 *  card". I1. With one debt left there's no "then" (ours). */
function planDebtDetailSentence(nowPaying, apr, thenPaying) {
    const now = apr === null ? nowPaying : `${nowPaying} (${apr})`;
    const then = thenPaying === null ? "" : `, then ${thenPaying}`;
    return `Extra on top of minimums · now paying ${now}${then}`;
}
/** PL-88: "$4,060 left on 2 cards · debt-free by May 2027". I1. When the included debts
 *  aren't all cards, they're "debts" (ours). */
function planDebtLeftSentence(left, count, allCards, debtFreeBy) {
    const what = allCards
        ? plural(count, "card", "cards")
        : plural(count, "debt", "debts");
    const head = `${left} left on ${what}`;
    return debtFreeBy === null ? head : `${head} · debt-free by ${debtFreeBy}`;
}
/** PL-09 / PL-125, the one Splash Fund definition (bubble, setup, Help, later Home).
 *  Part 1, verbatim. The button's name is SPLASH_FUND_INFO_LABEL_COPY
 *  ("What is Splash Fund?"). */
exports.PLAN_SPLASH_BUBBLE_TITLE_COPY = "Your guilt-free money";
exports.PLAN_SPLASH_BUBBLE_BODY_COPY = "Splash Fund is for discretionary spending: entertainment, dining out, shopping and other wants. What's left of it is your Safe to spend on Home.";
exports.PLAN_ADD_BUCKET_COPY = "+ Add a bucket"; // Part 1
/** Add a bucket's panel description, for screen readers (ours, the screen-reader pass,
 *  2026-10-22: the panel had a title and nothing saying what it is for). */
exports.PLAN_ADD_BUCKET_DESCRIPTION_COPY = "Choose what kind of bucket it is, name it, and set what it gets each pay period.";
exports.PLAN_SUGGESTED_COPY = "Suggested:"; // I1
/** I1: "Yearly costs · $15". Checking cushion has no amount (G13): just its name. */
function planSuggestionSentence(name, amount) {
    return amount === null ? name : `${name} · ${amount}`;
}
exports.PLAN_SET_UP_DEBT_PAYOFF_COPY = "Set up debt payoff"; // Part 1
// ── ③ Not planned yet (PL-11, PL-24) ───────────────────────────────────────────────
exports.PLAN_NOT_PLANNED_TITLE_COPY = "Not planned yet"; // Part 1
/** I1: "Anything left here is parked in Emergency fund on payday. You chose this in setup." */
function planNotPlannedParkedSentence(target) {
    return `Anything left here is parked in ${target} on payday. You chose this in setup.`;
}
/** What the page sends (ours, 2026-10-19): the server doesn't record whether parking was
 *  chosen in setup or on the page, so it doesn't claim setup. The sentence above is I1's. */
function planNotPlannedParkedNeutralSentence(target) {
    return `Anything left here is parked in ${target} on payday.`;
}
/** Unplanned, no parking (ours, from I2.7's "Leave it unplanned" line). */
exports.PLAN_NOT_PLANNED_UNPLANNED_COPY = "It isn't in a bucket, and covers overspending first.";
/** Overplanned (ours, from Part 1's "Buckets add up to more than what's left"). */
exports.PLAN_NOT_PLANNED_OVERPLANNED_COPY = "Your buckets add up to more than what's left after bills.";
exports.PLAN_PARK_IT_COPY = "Park it"; // Part 1
exports.PLAN_ADD_TO_BUCKET_COPY = "Add it to a bucket"; // ours, from Part 1's "add it to a bucket"
// ── If you spend more than planned (PL-12, PL-27, PL-104) ───────────────────────────
exports.PLAN_ORDER_TITLE_COPY = "If you spend more than planned"; // Part 1
exports.PLAN_ORDER_INTRO_COPY = "Your checking balance has to cover every bucket. If it can't, money comes out in this order:"; // I1
exports.PLAN_ORDER_NOT_PLANNED_COPY = "Not planned yet"; // Part 1
exports.PLAN_ORDER_SPLASH_FUND_COPY = "Splash Fund"; // Part 1
exports.PLAN_ORDER_EMERGENCY_FUND_COPY = "Emergency fund (in checking)"; // I1
exports.PLAN_ORDER_OTHER_GOALS_COPY = "Other goals in checking"; // I1
/** Item 5 names every essential (G5): "Groceries and Transportation". Part 1. */
function planOrderEssentialsLabel(names) {
    return joinNames(names);
}
exports.PLAN_ORDER_ALWAYS_FIRST_COPY = "Always first"; // I1
exports.PLAN_ORDER_ALWAYS_LAST_COPY = "Always last"; // I1
exports.PLAN_ORDER_FOOTNOTE_COPY = "Money you've moved to a savings account is never touched."; // I1
exports.PLAN_CHANGE_ORDER_COPY = "Change the order"; // Part 1
exports.PLAN_CHANGE_ORDER_IN_PLAN_COPY = "Change the order in Plan"; // I2.8
function planMoveUpLabel(item) {
    return `Move ${item} up`; // ours: the ↑ button's accessible name
}
function planMoveDownLabel(item) {
    return `Move ${item} down`; // ours: the ↓ button's accessible name
}
// ── Next payday (PL-13, G20) ────────────────────────────────────────────────────────
exports.PLAN_NEXT_PAYDAY_TITLE_COPY = "Next payday"; // Part 1
/** I1: "$3,800 · in 11 days"; "in 1 day"; "today" (ours). */
function planPaydayAmountSentence(amount, daysUntil) {
    const when = daysUntil <= 0 ? "today" : `in ${plural(daysUntil, "day", "days")}`;
    return `${amount} · ${when}`;
}
exports.PLAN_CHECKIN_PITCH_COPY = "A 2-minute check-in: confirm the paycheck, park what's left, and move your savings."; // I1
exports.PLAN_PREVIEW_CHECKIN_COPY = "Preview the check-in"; // Part 1
exports.PLAN_START_CHECKIN_COPY = "Start the check-in"; // G20 (his "Start check-in" is Home's)
// ── How your plan works (PL-14) ─────────────────────────────────────────────────────
exports.PLAN_HOW_IT_WORKS_TITLE_COPY = "How your plan works"; // Part 1
exports.PLAN_HOW_IT_WORKS_BILLS_COPY = "Bills come out first. You plan what's left."; // I1
exports.PLAN_HOW_IT_WORKS_PURCHASES_COPY = "Purchases come out of the right bucket on their own, by category."; // I1
exports.PLAN_HOW_IT_WORKS_UNSPENT_COPY = "Unspent money stays in its bucket and builds up."; // I1
// ── Special states (PL-110–PL-120) ──────────────────────────────────────────────────
/** PL-46 / PL-117: "Changes start Oct 26." Part 1. */
function planNextPeriodBanner(start) {
    return `Changes start ${start}.`;
}
/** G41 (ours, flagged; amends G8's wording, which collides with PLAN_OVERPLANNED_COPY):
 *  coverage took all it could and checking is still short of what the plan must hold. */
function planCheckingShortUncoveredSentence(amount) {
    return `Checking is ${amount} short of your plan, and there's nothing left to cover it from.`;
}
/** PL-118: "This paycheck was $200 less, so there's less to plan". Part 1. */
function planPaycheckLessBanner(amount) {
    return `This paycheck was ${amount} less, so there's less to plan`;
}
exports.PLAN_REVIEW_PLAN_COPY = "Review plan"; // Part 1
/** PL-119: Home's banner, the same words. */
exports.PLAN_SYNC_FAILED_COPY = homeSummary_1.HOME_BANK_UNREACHABLE_LEAD;
/** PL-120 / RD-11: "Not found yet. Confirm your paycheck". */
exports.PLAN_NO_PAYCHECK_COPY = `${moneyDefinitionsCopy_1.PAYCHECK_NOT_FOUND_COPY}. ${moneyDefinitionsCopy_1.CONFIRM_YOUR_PAYCHECK_COPY}`;
// ── Editing an amount (PL-40–PL-45, G10, G11, G15) ──────────────────────────────────
/** "Plan each pay period (now $300)". Part 1. */
function planStepperLabel(now) {
    return `Plan each pay period (now ${now})`;
}
/** PL-41, raising with parking. Part 1. */
function planRaiseFromParkedSentence(delta, target, from, to) {
    return `The extra ${delta} comes from the money that would go to your ${target} on payday: ${from} → ${to}.`;
}
/** PL-41, lowering with parking. Part 1. */
function planLowerToParkedSentence(delta, target, from, to) {
    return `The ${delta} goes to your ${target} on payday instead: ${from} → ${to}.`;
}
/** PL-41, no parking. Part 1. */
function planNoParkingSentence(from, to) {
    return `Not planned yet ${from} → ${to}.`;
}
/** G10, raising while money is unplanned. */
function planRaiseFromNotPlannedSentence(delta, from, to) {
    return `The extra ${delta} comes from Not planned yet: ${from} → ${to}.`;
}
/** PL-42, raising past what's parked. Part 1. */
function planShortfallParkedSentence(delta, available, target, short) {
    return `The extra ${delta} uses all ${available} headed to your ${target} on payday, and still needs ${short} more.`;
}
/** PL-42's pattern with unplanned money instead of parking (ours). */
function planShortfallNotPlannedSentence(delta, available, short) {
    return `The extra ${delta} uses all ${available} not planned yet, and still needs ${short} more.`;
}
/** PL-42's pattern with nothing to draw on (Paul, 2026-10-19). */
function planShortfallNothingSentence(delta) {
    return `There's nothing left to plan, so the extra ${delta} has to come from another bucket.`;
}
/** "Take $14 from:". Part 1. */
function planTakeFromLabel(amount) {
    return `Take ${amount} from:`;
}
/** I6: "Emergency fund ($250)". */
function planTakeFromChoiceSentence(name, available) {
    return `${name} (${available})`;
}
exports.PLAN_CANCEL_COPY = "Cancel"; // Part 1
exports.PLAN_SAVE_COPY = "Save"; // Part 1
/** PL-43: "From now on, Groceries gets $340 each pay period". Part 1. */
function planFromNowOnSentence(name, amount) {
    return `From now on, ${name} gets ${amount} each pay period`;
}
exports.PLAN_RENAME_COPY = "Rename"; // ours (PL-45: "rename and delete")
exports.PLAN_DELETE_BUCKET_COPY = "Delete bucket"; // ours
/** The editor's field labels (ours: his editor draws the fields, not their labels). */
exports.PLAN_EDIT_CATEGORIES_COPY = "Categories"; // ours
exports.PLAN_EDIT_ADD_CATEGORY_COPY = "Add a category"; // ours
/** PL-90 / G16 (ours, flagged; agreed with web 2026-10-20): a category chip opens Settings →
 *  Rules on that category, which shows its merchant rules and, read-only, its bucket, with a
 *  link back to the Plan row. Plan is the one editor of which bucket a category fills. */
function planCategoryRulesBucketSentence(bucket) {
    return `Purchases in this category fill your ${bucket} bucket.`;
}
exports.PLAN_CATEGORY_RULES_NO_BUCKET_COPY = "This category isn't in a bucket yet.";
/** The link to the bucket's row on Plan (ownerLink `row=bucket:<key>`). */
exports.PLAN_CATEGORY_RULES_CHANGE_ON_PLAN_COPY = "Change it on Plan";
function planCategoryRulesEmptySentence(category) {
    return `No rules for ${category} yet.`;
}
exports.PLAN_EDIT_TARGET_COPY = "Target"; // ours
exports.PLAN_EDIT_KEPT_IN_COPY = "Kept in"; // ours
/** The stepper's − and + buttons, by name (ours; mobile's sheet labels, now shared):
 *  "$10 less", "1% more". `step` comes preformatted. */
function planStepLessLabel(step) {
    return `${step} less`;
}
function planStepMoreLabel(step) {
    return `${step} more`;
}
/** The × on a category chip in the editor (ours): "Remove Groceries". */
function planRemoveCategoryLabel(name) {
    return `Remove ${name}`;
}
/** PL-90's web half (ours): on Settings → Rules focused on one category, the link back to
 *  every rule. */
exports.PLAN_CATEGORY_RULES_SHOW_ALL_COPY = "Show all rules"; // ours
/** PL-10's "Adding offers a spending bucket, a savings goal, or a debt" (ours; the debt
 *  choice is Debt payoff by its own name). */
exports.PLAN_ADD_SPENDING_COPY = "Spending bucket"; // ours
exports.PLAN_ADD_SAVINGS_GOAL_COPY = "Savings goal"; // ours
exports.PLAN_BUCKET_NAME_COPY = "Name"; // ours
/** PL-45 rename (Paul, 2026-10-20; all ours): the longest name a bucket can have, and the
 *  400 `detail` of each refusal from `POST /api/plan/buckets/<id>/rename/`. Splash Fund
 *  keeps its name (a defined term). */
exports.PLAN_BUCKET_NAME_MAX_LENGTH = 40;
exports.PLAN_RENAME_EMPTY_COPY = "Give the bucket a name."; // ours
/** Derived from the limit, so a new limit can't leave the sentence wrong (ours). */
exports.PLAN_RENAME_TOO_LONG_COPY = `Keep the name to ${exports.PLAN_BUCKET_NAME_MAX_LENGTH} characters or fewer.`;
exports.PLAN_RENAME_DUPLICATE_COPY = "You already have a bucket with that name."; // ours
exports.PLAN_RENAME_SPLASH_COPY = "Splash Fund keeps its name."; // ours
/** G15: the planned amount returns to Not planned yet (Part 1's "its money goes back to
 *  Not planned yet"). */
function planArchiveReturnsSentence(amount) {
    return `Its ${amount} goes back to Not planned yet.`;
}
/** G15, a balance held in checking: "The $2,600 it holds stops being set aside". */
function planArchiveHeldInCheckingSentence(balance) {
    return `The ${balance} it holds stops being set aside`;
}
/** G15, a balance moved to savings (ours). */
function planArchiveHeldInSavingsSentence(balance) {
    return `The ${balance} it holds stays in your savings account`;
}
// ── First-time setup (PL-50–PL-58), I2 ──────────────────────────────────────────────
/** Intro pill: "$1,716 after bills". */
function planSetupAfterBillsPill(amount) {
    return `${amount} after bills`;
}
/** "$1,326 left to plan". Part 1. */
function planSetupLeftToPlanPill(amount) {
    return `${amount} left to plan`;
}
exports.PLAN_SETUP_INTRO_KICKER_COPY = "Your money, figured out";
exports.PLAN_SETUP_INTRO_HEADING_COPY = "After bills, you have this much until your next paycheck";
exports.PLAN_SETUP_INTRO_BODY_COPY = "Nothing is set aside yet, so groceries and gas come out of this too. Want to bucket it? We'll suggest amounts from how you've spent over the last 12 months. You can change or skip any of them.";
/** G37 (ours): the intro body for a user who already has accepted buckets; the server
 *  sends the right one as the intro's `body`. */
exports.PLAN_SETUP_INTRO_BODY_PLANNED_COPY = "Some of this already has a job in your buckets. Want to plan the rest? We'll suggest amounts from how you've spent over the last 12 months. You can change or skip any of them.";
exports.PLAN_SETUP_COMING_IN_COPY = "Coming in";
exports.PLAN_SETUP_BILLS_COPY = "Bills";
exports.PLAN_SETUP_PAY_PERIOD_COPY = "Pay period";
exports.PLAN_SETUP_NOT_NOW_COPY = "Not now"; // Part 1
exports.PLAN_SETUP_BUCKET_IT_COPY = "Yes, bucket it";
exports.PLAN_SETUP_TAB_ESSENTIALS_COPY = "Essentials";
exports.PLAN_SETUP_TAB_SPLASH_COPY = "Splash Fund";
exports.PLAN_SETUP_TAB_DEBTS_COPY = "Debts & loans";
exports.PLAN_SETUP_TAB_SAVINGS_COPY = "Savings";
exports.PLAN_SETUP_TAB_GOALS_COPY = "Goals";
exports.PLAN_SETUP_TAB_WHATS_LEFT_COPY = "What's left";
exports.PLAN_SETUP_BACK_COPY = "Back";
exports.PLAN_SETUP_SKIP_COPY = "Skip";
/** A skipped step on setup's strip, for screen readers (ours, 2026-10-19). */
exports.PLAN_SETUP_STEP_SKIPPED_COPY = "Skipped";
exports.PLAN_SETUP_NEXT_COPY = "Next";
exports.PLAN_EACH_PAY_PERIOD_COPY = "each pay period";
exports.PLAN_SETUP_ESSENTIALS_KICKER_COPY = "Step 1 · Essentials first";
exports.PLAN_SETUP_ESSENTIALS_HEADING_COPY = "Set aside groceries and getting around";
exports.PLAN_SETUP_ESSENTIALS_BODY_COPY = "These come first so a fun weekend never eats your grocery money. Purchases in these categories come out of each bucket on their own.";
/** "You usually spend $284. Supermarkets and warehouse clubs." */
function planSetupUsuallySentence(usual, seen) {
    return `You usually spend ${usual}. ${seen}`;
}
exports.PLAN_SETUP_SPLASH_KICKER_COPY = "Step 2 · Guilt-free spending";
exports.PLAN_SETUP_SPLASH_HEADING_COPY = "Want a Splash Fund?";
/** "You spent about $512 a pay period on dining out, shopping and entertainment. Pick an
 *  amount you can enjoy without checking." */
function planSetupSplashBody(usual) {
    return `You spent about ${usual} a pay period on dining out, shopping and entertainment. Pick an amount you can enjoy without checking.`;
}
exports.PLAN_SETUP_SPLASH_OPTION_COPY = "Dining out, shopping, entertainment and other wants.";
/** The inline explainer's heading; its body is PLAN_SPLASH_BUBBLE_BODY_COPY (PL-125:
 *  one definition, so not I2.3's own wording). */
exports.PLAN_SETUP_SPLASH_EXPLAINER_COPY = "What's Splash Fund?";
exports.PLAN_SETUP_DEBTS_KICKER_COPY = "Step 3 · Debts & loans";
exports.PLAN_SETUP_DEBTS_HEADING_COPY = "We found these debts and loans";
/** A setup answer for a step that is no longer current (another tab or device moved on):
 *  the 400's `detail` (ours, 2026-10-19). The app reloads setup. */
exports.PLAN_SETUP_STEP_CHANGED_COPY = "This step has changed. We've reloaded it.";
exports.PLAN_SETUP_DEBTS_QUESTION_COPY = "Which do you want to pay off faster?"; // Part 1
exports.PLAN_SETUP_PAYS_IN_FULL_COPY = "I pay it in full"; // Part 1
/** "Carrying $3,420 at 22.9% APR". */
function planSetupCarryingSentence(balance, apr) {
    return `Carrying ${balance} at ${apr} APR`;
}
/** "$412 a month, already in your bills · $9,800 left". */
function planSetupLoanSentence(monthly, left) {
    return `${monthly} a month, already in your bills · ${left} left`;
}
/** Paul 2026-10-23 (option 1): a debt found from payments, not confirmed yet. */
function planSetupFoundDebtSentence(monthly) {
    return `Pays ${monthly} a month. Add its balance to include it.`;
}
/** Paul 2026-10-23: a found debt whose payments stopped, listed unticked. */
function planSetupStoppedDebtSentence(month) {
    return `Payments stopped in ${month}.`;
}
/** Next with a ticked found debt still missing its balance (ours). */
function planSetupFoundNeedsDetailsSentence(name) {
    return `Add ${name}'s balance to include it, or untick it.`;
}
/** I2.4: "From your payments we spotted 2 credit cards carrying a balance and 2 loans.
 *  Minimum payments are already in your bills. Paying extra gets you out of debt sooner." */
function planSetupDebtsBody(cards, loans) {
    const found = [
        cards > 0
            ? `${plural(cards, "credit card", "credit cards")} carrying a balance`
            : null,
        loans > 0 ? plural(loans, "loan", "loans") : null,
    ].filter((p) => p !== null);
    return `From your payments we spotted ${joinNames(found)}. Minimum payments are already in your bills. Paying extra gets you out of debt sooner.`;
}
exports.PLAN_SETUP_DEBT_EXTRA_COPY = "Extra toward debt each paycheck";
exports.PLAN_SETUP_DEBT_EXTRA_BODY_COPY = "On top of the minimums. We aim at the highest rate first; change the order anytime in Debt payoff.";
exports.PLAN_SETUP_DOLLARS_TOGGLE_COPY = "$ amount";
exports.PLAN_SETUP_PCT_TOGGLE_COPY = "% of what's left";
exports.PLAN_SETUP_SAVINGS_KICKER_COPY = "Step 4 · Savings";
exports.PLAN_SETUP_SAVINGS_HEADING_COPY = "Build an emergency fund";
/** "… Most people aim for one month of bills, about $5,000 for you." */
function planSetupSavingsBody(target) {
    return `A cushion for surprises like a car repair or a vet bill. Most people aim for one month of bills, about ${target} for you.`;
}
exports.PLAN_SETUP_HAS_SAVINGS_QUESTION_COPY = "Do you have a savings account?"; // Part 1
exports.PLAN_SETUP_HAS_SAVINGS_YES_COPY = "Yes";
exports.PLAN_SETUP_YES_DETAIL_COPY = "We'll remind you to move it on payday";
exports.PLAN_SETUP_NOT_YET_COPY = "Not yet";
exports.PLAN_SETUP_NOT_YET_DETAIL_COPY = "It stays set aside in checking";
exports.PLAN_SETUP_EF_IN_SAVINGS_COPY = "Move it to savings on payday. We'll remind you.";
/** The Not-yet twin of PLAN_SETUP_EF_IN_SAVINGS_COPY. Ours, from I1's "Kept in checking,
 *  so it can cover overspending". */
exports.PLAN_SETUP_EF_IN_CHECKING_COPY = "Keep it in checking, so it can cover overspending.";
exports.PLAN_SETUP_GOALS_KICKER_COPY = "Step 5 · Anything you're saving for?";
exports.PLAN_SETUP_GOALS_HEADING_COPY = "Plan for things coming up";
exports.PLAN_SETUP_GOALS_BODY_COPY = "Pick what matters to you. We work out how much to set aside each paycheck.";
/** "$3,000 by June 1. You have $1,200 saved." */
function planSetupGoalSentence(target, date, saved) {
    return `${target} by ${date}. You have ${saved} saved.`;
}
/** G39 (ours, Paul 2026-10-20): the goal's pace was capped at what fits, so the date
 *  that amount reaches (G27's computed date): "$3,000, ready by March at this amount.
 *  You have $1,200 saved." */
function planSetupGoalCappedSentence(target, readyBy, saved) {
    return `${target}, ready by ${readyBy} at this amount. You have ${saved} saved.`;
}
/** G39 (ours): nothing is left to plan for the goal this paycheck. */
function planSetupGoalNoRoomSentence(target, date, saved) {
    return `${target} by ${date}. Nothing is left to plan for it this paycheck. You have ${saved} saved.`;
}
exports.PLAN_SETUP_ADD_ANOTHER_COPY = "Add another:";
exports.PLAN_SETUP_WHATS_LEFT_KICKER_COPY = "Almost done";
/** "You have $146 not planned yet". Part 1. */
function planSetupWhatsLeftHeading(amount) {
    return `You have ${amount} not planned yet`;
}
exports.PLAN_SETUP_WHATS_LEFT_BODY_COPY = "Money that isn't planned is easy to spend without noticing. Parking it in your Emergency fund keeps it safe, and you can move it later.";
/** "Park in Emergency fund". */
function planParkInCopy(target) {
    return `Park in ${target}`;
}
/** "Emergency fund becomes $396 this period". */
function planSetupParkDetail(target, becomes) {
    return `${target} becomes ${becomes} this period`;
}
exports.PLAN_SETUP_ANOTHER_BUCKET_COPY = "Put it in another bucket";
exports.PLAN_SETUP_ANOTHER_BUCKET_DETAIL_COPY = "Choose which one on the next screen";
exports.PLAN_SETUP_LEAVE_COPY = "Leave it unplanned";
exports.PLAN_SETUP_LEAVE_DETAIL_COPY = "It shows as 'Not planned yet' and covers overspending first";
exports.PLAN_EVERY_PAYDAY_COPY = "Do this every payday without asking"; // Part 1
exports.PLAN_SETUP_FINISH_COPY = "Finish";
exports.PLAN_SETUP_DONE_KICKER_COPY = "Your plan is ready";
exports.PLAN_SETUP_DONE_HEADING_COPY = "Every dollar after bills has a job";
exports.PLAN_SETUP_EACH_PAY_PERIOD_COPY = "Each pay period";
/** "Emergency fund (incl. $146 parked)". */
function planSetupDoneParkedName(name, parked) {
    return `${name} (incl. ${parked} parked)`;
}
/** A name-and-amount row read as one line: a done row ("Groceries, $300") or a waterfall
 *  row ("Upcoming bills, -$368"). Ours, in the pattern of Part 1's "Extra debt payment,
 *  $300". */
function planNameAmountSentence(name, amount) {
    return `${name}, ${amount}`;
}
exports.PLAN_SETUP_DONE_ORDER_BODY_COPY = "Money comes out in this order. Groceries and transportation are protected until last.";
exports.PLAN_GO_TO_HOME_COPY = "Go to Home"; // Part 1
// ── The no-buckets stages (PL-60–PL-64), I3–I5 ──────────────────────────────────────
/** "Thursday, Oct 15 · Next payday Mon, Oct 26 ($3,800)". */
function planStagesHeader(today, payday, amount) {
    return `${today} · Next payday ${payday} (${amount})`;
}
exports.PLAN_UNTIL_PAYDAY_COPY = "Until payday"; // Part 1
/** Stage 1: "Your checking balance, minus the bills our analysis expects before Oct 26." */
function planWaterfallStage1Sentence(payday) {
    return `Your checking balance, minus the bills our analysis expects before ${payday}.`;
}
exports.PLAN_WATERFALL_STAGE2_COPY = "Your checking balance, minus upcoming bills and your spending buckets.";
exports.PLAN_WATERFALL_STAGE3_COPY = "Your checking balance, minus upcoming bills and every bucket.";
exports.PLAN_WATERFALL_BALANCE_COPY = "Current balance"; // Part 1
exports.PLAN_WATERFALL_BILLS_COPY = "Upcoming bills"; // Part 1
exports.PLAN_WATERFALL_REMAINING_COPY = "Remaining balance"; // Part 1
exports.PLAN_BILLS_FOUND_COPY = "Bills our analysis found before payday";
exports.PLAN_SEE_FIX_BILLS_COPY = "See or fix bills in Upcoming";
exports.PLAN_USUAL_TITLE_COPY = "What you usually spend each pay period"; // Part 1
/** PL-32: "Average per pay period (every 2 weeks), from 12 months of transactions,
 *  Oct 2025 – Sep 2026. Bills aren't included." */
function planUsualSentence(frequency, from, to) {
    return `Average per pay period (${frequency}), from 12 months of transactions, ${from} – ${to}. Bills aren't included.`;
}
/** G1: Stage 1 describes Splash Fund's categories; the bucket is Splash Fund. */
exports.PLAN_STAGE1_SPLASH_DESCRIPTION_COPY = "Discretionary: dining out, shopping, entertainment";
/** PL-62: Splash Fund's split names its three largest categories, then this part for
 *  the rest, so the parts add up to the row's usual. Sent by the server as a part's name. */
exports.PLAN_STAGE1_OTHER_PART_COPY = "Other";
exports.PLAN_STAGE1_ASK_COPY = "Create buckets for these categories? Each bucket starts at your average. You can change any amount later.";
/** "Create 3 buckets". Part 1. */
function planCreateBucketsCopy(count) {
    return `Create ${plural(count, "bucket", "buckets")}`;
}
/** "3 spending buckets created at your averages." */
function planStage2Banner(count) {
    return `${plural(count, "spending bucket", "spending buckets")} created at your averages.`;
}
exports.PLAN_STAGE2_ASK_COPY = "Create buckets for your remaining balance?"; // Part 1
/** "You have $4,362 remaining after bills and your spending buckets. Give some of it a
 *  job each pay period." */
function planStage2Sentence(remaining) {
    return `You have ${remaining} remaining after bills and your spending buckets. Give some of it a job each pay period.`;
}
exports.PLAN_MORE_GOALS_COPY = "More goals:";
exports.PLAN_OTHER_GOAL_COPY = "Other goal";
/** "4 buckets · $740 each pay period · $3,622 would remain". Part 1. */
function planLiveLineSentence(count, total, remaining) {
    return `${plural(count, "bucket", "buckets")} · ${total} each pay period · ${remaining} would remain`;
}
exports.PLAN_SKIP_FOR_NOW_COPY = "Skip for now"; // Part 1
/** "7 buckets set. Your plan is ready." */
function planStage3Banner(count) {
    return `${plural(count, "bucket", "buckets")} set. Your plan is ready.`;
}
/** Stage 2's live line, by the name mobile asked for; the same words. */
exports.planStageLiveLine = planLiveLineSentence;
/** "$1,622 each pay period". */
function planEachPayPeriodTotal(total) {
    return `${total} each pay period`;
}
exports.PLAN_TYPE_SPENDING_AVERAGE_COPY = "Spending · your average";
exports.PLAN_TYPE_SAVINGS_COPY = "Savings";
exports.PLAN_TYPE_DEBT_COPY = "Debt";
exports.PLAN_TYPE_GOAL_COPY = "Goal";
/** I4's Emergency fund reason: "A cushion for surprises. You already move about $150 to
 *  savings most paydays." The second sentence only when the analysis sees regular moves. */
function planStageEmergencyReason(usualMove) {
    const head = "A cushion for surprises.";
    return usualMove === null
        ? head
        : `${head} You already move about ${usualMove} to savings most paydays.`;
}
/** I4's Debt payoff reason: "On top of minimums. We found 2 cards carrying $4,060, a car
 *  loan and a student loan." Loans by their type ("car loan"). */
function planStageDebtReason(cards, cardBalance, loans) {
    const found = [
        ...(cards > 0
            ? [`${plural(cards, "card", "cards")} carrying ${cardBalance}`]
            : []),
        ...loans.map((loan) => `a ${loan}`),
    ];
    return `On top of minimums. We found ${joinNames(found)}.`;
}
exports.PLAN_STAGE_TRIP_REASON_COPY = "Save toward your next getaway."; // I4
/** I4's Holidays & gifts reason: "Last December you spent about $480 more than usual." */
function planStageHolidaysReason(extra) {
    return `Last December you spent about ${extra} more than usual.`;
}
// ── The payday check-in (PL-70–PL-77), I7 ───────────────────────────────────────────
exports.PLAN_CHECKIN_TITLE_COPY = "Payday check-in · about 2 minutes";
exports.PLAN_CHECKIN_STEP_PAYCHECK_COPY = "Paycheck";
exports.PLAN_CHECKIN_STEP_PLAN_COPY = "Plan";
exports.PLAN_CHECKIN_STEP_MOVE_COPY = "Move money";
exports.PLAN_CHECKIN_PAYCHECK_HEADING_COPY = "Your paycheck landed"; // Part 1
/** "Mon, Oct 26 · Paycheck". */
function planCheckinPaycheckLabel(date) {
    return `${date} · Paycheck`;
}
exports.PLAN_CHECKIN_MATCHES_COPY = "Matches what we expected";
/** The difference, when it doesn't match (ours, from PL-118's banner). */
function planCheckinDiffersCopy(amount, less) {
    return `${amount} ${less ? "less" : "more"} than we expected`;
}
/** "This starts your Oct 26 – Nov 8 pay period. Your 2nd paycheck ($1,100) is expected
 *  Oct 29." The second sentence only when there is a second paycheck. */
function planCheckinPeriodSentence(start, end, second) {
    const head = `This starts your ${start} – ${end} pay period.`;
    return second === null
        ? head
        : `${head} Your 2nd paycheck (${second.amount}) is expected ${second.date}.`;
}
exports.PLAN_CHECKIN_AMOUNT_DIFFERENT_COPY = "Amount is different"; // Part 1
/** G31 (Paul, 2026-10-19): while an "Amount is different" correction is above what has
 *  arrived, only what we've seen counts: "We saw $3,800 arrive; the rest counts when it
 *  does". The server sends it as `correction_note`; neither app composes it. */
function planCorrectionSeenSentence(seen) {
    return `We saw ${seen} arrive; the rest counts when it does`;
}
/** The label of the field "Amount is different" opens (PL-71). Ours. */
exports.PLAN_CHECKIN_AMOUNT_LABEL_COPY = "The amount that landed";
/** The preview's notice (PL-77: read-only, saving nothing). Ours. */
exports.PLAN_CHECKIN_PREVIEW_NOTICE_COPY = "This is a preview. Nothing here is saved.";
exports.PLAN_CHECKIN_THATS_RIGHT_COPY = "Yes, that's right";
/** "$1,716 left after bills". Part 1. */
function planCheckinPlanHeading(amount) {
    return `${amount} left after bills`;
}
/** "Here's your plan for Oct 26 – Nov 8. Unspent money stays in its bucket: Groceries
 *  carries $34, Transportation $12 and Splash Fund $61." Carries are preformatted as
 *  [name, amount]; with none, the first sentence alone. */
function planCheckinPlanSentence(start, end, carries) {
    const head = `Here's your plan for ${start} – ${end}.`;
    if (carries.length === 0)
        return head;
    const [first, ...rest] = carries;
    const items = [
        `${first[0]} carries ${first[1]}`,
        ...rest.map(([n, a]) => `${n} ${a}`),
    ];
    return `${head} Unspent money stays in its bucket: ${joinNames(items)}.`;
}
exports.PLAN_CHECKIN_ANOTHER_BUCKET_COPY = "Another bucket";
exports.PLAN_CHECKIN_ANOTHER_BUCKET_DETAIL_COPY = "You pick which";
exports.PLAN_CHECKIN_LEAVE_COPY = "Leave it";
exports.PLAN_CHECKIN_LEAVE_DETAIL_COPY = "Stays unplanned";
/** "Becomes $396". */
function planCheckinBecomesCopy(amount) {
    return `Becomes ${amount}`;
}
exports.PLAN_OPEN_FULL_PLAN_COPY = "Open the full plan";
exports.PLAN_USE_THIS_PLAN_COPY = "Use this plan";
/** G22: "Groceries went over twice. Raise to $340?" Part 1. */
function planRaiseSuggestionSentence(name, times, to) {
    const count = times === 1 ? "once" : times === 2 ? "twice" : `${times} times`;
    return `${name} went over ${count}. Raise to ${to}?`;
}
exports.PLAN_CHECKIN_MOVE_HEADING_COPY = "Move your money"; // Part 1
exports.PLAN_CHECKIN_MOVE_BODY_COPY = "Do these in your bank app. We'll tick them off on our own when we see them.";
/** The sentence naming what's kept in checking: "Your Emergency fund ($396) stays in
 *  checking, as you chose, so there's nothing to move for it." */
function planCheckinKeptInCheckingSentence(name, amount) {
    return `Your ${name} (${amount}) stays in checking, as you chose, so there's nothing to move for it.`;
}
/** I7.3's whole sub-line: the body, then the kept-in-checking sentence when a set-aside
 *  bucket stays in checking. */
function planCheckinMoveSentence(kept) {
    return kept === null
        ? exports.PLAN_CHECKIN_MOVE_BODY_COPY
        : `${exports.PLAN_CHECKIN_MOVE_BODY_COPY} ${planCheckinKeptInCheckingSentence(kept.name, kept.amount)}`;
}
exports.PLAN_CHECKING_TO_SAVINGS_COPY = "Checking → Savings";
exports.PLAN_EXTRA_DEBT_PAYMENT_COPY = "Extra debt payment";
/** "To your Store card first, on top of the minimum". */
function planDebtMoveDetail(name) {
    return `To your ${name} first, on top of the minimum`;
}
exports.PLAN_START_MY_PERIOD_COPY = "Start my pay period";
/** "You're set until Nov 8". Part 1. */
function planCheckinDoneHeading(date) {
    return `You're set until ${date}`;
}
exports.PLAN_SAFE_UNTIL_PAYDAY_COPY = "Safe to spend until payday";
/** "Splash Fund: $480 new + $61 carried over · about $38 a day". */
function planCheckinDoneSentence(fresh, carried, perDay) {
    return `Splash Fund: ${fresh} new + ${carried} carried over · about ${perDay} a day`;
}
exports.PLAN_BACK_TO_HOME_COPY = "Back to Home";
/** PL-75, Home's item until step 2 is done. Part 1. */
exports.PLAN_FINISH_CHECKIN_COPY = "Finish your payday check-in";
exports.PLAN_NOT_MOVED_YET_COPY = "Not moved yet"; // Part 1
// ── What Home shows from Plan (PL-28, PL-87): items /api/home/ carries ──────────────
/** "Groceries went $40 over. We covered it from your Splash Fund." Part 1. */
function planCoveredHomeSentence(name, amount, from) {
    return `${name} went ${amount} over. We covered it from your ${from}.`;
}
/** "Extra debt payment, $300". Part 1. */
function planExtraDebtMoveSentence(amount) {
    return `Extra debt payment, ${amount}`;
}
/** Rule 17 (Paul, 2026-10-20: all wording in shared copy). The server's existing Home
 *  items, now twinned here word for word. A cover from money not planned yet:
 *  "Groceries went $40 over. We covered it from money not planned yet." */
function planCoveredFromNotPlannedSentence(name, amount) {
    return `${name} went ${amount} over. We covered it from money not planned yet.`;
}
/** PL-26's balance check: "Checking was $40 short of your plan. We covered it from your Splash Fund." */
function planCheckingShortSentence(amount, from) {
    return `Checking was ${amount} short of your plan. We covered it from your ${from}.`;
}
/** "Checking was $40 short of your plan. We covered it from money not planned yet." */
function planCheckingShortFromNotPlannedSentence(amount) {
    return `Checking was ${amount} short of your plan. We covered it from money not planned yet.`;
}
/** PL-75: "Not moved yet: Vacation, $150" / "Not moved yet: Extra debt payment, $300". */
function planNotMovedYetSentence(what, amount) {
    return `Not moved yet: ${what}, ${amount}`;
}
/** "We found 2 credit cards and 2 loans. Plan to pay them down?" Part 1. */
function planDebtsFoundSentence(cards, loans) {
    const parts = [
        cards > 0 ? plural(cards, "credit card", "credit cards") : null,
        loans > 0 ? plural(loans, "loan", "loans") : null,
    ].filter((p) => p !== null);
    return `We found ${joinNames(parts)}. Plan to pay them down?`;
}
/** "Store card first". Part 1. */
function planDebtFirstCopy(name) {
    return `${name} first`;
}
// ── Debt payoff, the interim view (F5: PL-80 to PL-86). All ours, flagged. ─────────────
/** PL-84: one strategy's line, "Saves $812 in interest · debt-free by April 2027" (ours). */
function planDebtStrategySummary(interestSaved, debtFreeBy) {
    const head = `Saves ${interestSaved} in interest`;
    return debtFreeBy === null ? head : `${head} · debt-free by ${debtFreeBy}`;
}
/** PL-84/85: a strategy that never finishes at the shown extra (ours). */
exports.PLAN_DEBT_NEVER_PAID_OFF_COPY = "At this amount, these debts don't get paid off.";
/** PL-83: the per-debt tick (ours). */
exports.PLAN_DEBT_INCLUDE_COPY = "Include in Debt payoff";
/** PL-82: the APR field's label, and why it's asked (ours). */
exports.PLAN_DEBT_APR_LABEL_COPY = "APR";
exports.PLAN_DEBT_APR_NEEDED_COPY = "We don't know this rate yet. Add it to put this debt in order.";
/** PL-82: a debt whose APR isn't known yet, "Carrying $500" (ours). */
function planDebtCarryingSentence(balance) {
    return `Carrying ${balance}`;
}
//# sourceMappingURL=planCopy.js.map